import config from 'config'
import { Job } from 'types/Job'
import { fetchWithToken } from 'utils'

/**
 * Retrieves the organization jobs for the notifications drawer
 * Can also be used to fetch a single job with metadata
 */
const fetchJobs = ({
  accountKey,
  adminKey,
  fromDate,
  jobId,
}: {
  accountKey: string
  adminKey?: string
  fromDate?: number
  jobId?: string
}): Promise<Job[] | Job> => {
  const externalAdminUrl = config.EXTERNAL_ADMIN_URL
  const baseUrl = `${externalAdminUrl}/ext-admin/rest/accounts/${accountKey}/jobs`

  const route = jobId
    ? `${baseUrl}/${jobId}?metadata=true`
    : `${baseUrl}?fromDate=${fromDate}&toDate=${new Date().getTime()}&metadata=true&normalizeRequestContent=true&filter=((admin.key eq "${adminKey}"))`

  return fetchWithToken({
    method: 'GET',
    externalUrl: route,
  })
    .then((response: Response) => response.json())
    .then((response) => (jobId ? response : response?.results || []))
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
      return []
    })
}

export default fetchJobs
